import styles from "./chatNotesInner.module.scss";
//import notesimg from "../../../../styles/images/notessvg.svg";
import React, { useEffect } from "react";
import moment from "moment";
import { chatSideWindow } from "../../../../base/eventService/eventApiService";
import { toastInformation } from "../../../../base/callService/common";
import { eventService } from "../../../../base/eventService/event.service";
type notesMessageProps = {
  notesData:any
  searchedData?: any;
}
export default function ChatNotesInner({notesData,searchedData}:notesMessageProps) {

  useEffect(() => {

  }, [searchedData]);

  let message_text = notesData && notesData?.summary?.length > 25 ? notesData?.summary?.substring(0, 27) + "..." :
    notesData?.summary || "";
  
  message_text= message_text
    ?.replace(/(\b(https?|ftp|file):\/\/[-A-Z0-9+&@#\\/%?=~_|!:,.;]*[-A-Z0-9+&@#\\/%=~_|])/img,
      '<a href="$1" target="__blank">$1</a>');
  message_text = message_text?.replace(/\n/g, "<br />");
  if(searchedData!=="" && searchedData!== undefined){
    const regexs = new RegExp('('+searchedData+')', 'gi');
    message_text = message_text?.replace(regexs,
      '<span style="background-color:#FFFF00" tabindex="0" class="tranText">$1</span>');
  }
  const showNote = () => {
    
    new eventService().getNoteByUid(notesData.uid)
      .then((response: any) => {
        if (response.status === "Ok") { chatSideWindow(true, "editnotes", response.result); }
        else {
          toastInformation("Note not found", "failure");
        }
      })
      .catch((err: any) => {
        console.log("err---", err);
      });

  };
  return (
    <>
      <div className={`chatFilesInner ${styles.filesChat}`} onClick={showNote}>
        <div className={styles.filesDetails}>
          <span className={styles.fileName}>
            <span className={styles.iconTask}></span>
            <span dangerouslySetInnerHTML={{ __html: message_text?.replace(/\n/g, "<br />") }}></span>
          </span>
          <span className={styles.fileDt}>Created on {notesData.lastModified
           && moment(new Date(parseInt(notesData.lastModified))).format('ll')}</span>
        </div>
      </div>
    </>
  );
};
